export default __webpack_public_path__ + "static/media/html.858b966f.svg";